import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'eiq-checkbox-card',
  templateUrl: 'checkbox-card.component.html',
  styleUrls: ['checkbox-card.component.scss']
})
export class CheckboxCardComponent {
  @Input() title!: string;
  @Input() subtitle: string;
  @Input() image: string;
  @Input() checked: boolean;
  @Input() color: ThemePalette;

  @Output() change = new EventEmitter<MatCheckboxChange>();
}
